import ApiBase from '@/services/ApiBase';
import { API_URL, getApiUrl } from '@/utils/api';
import { CartModel } from '@/models';
import { ProviderInterface } from '@/services/ProviderInterface';
import { AppDispatch } from '@/redux/create-store';

export class PayjunctionService extends ApiBase implements ProviderInterface {
  static userCartUrl = getApiUrl(API_URL.USER, '/cart');

  async load(): Promise<Record<string, unknown>> {
    return new Promise((resolve) => {
      resolve({ status: 'success' });
    });
  }

  async initPaymentProvider() {
    return true;
  }

  async createPaymentProviderForm() {
    return;
  }

  async processPayment() {
    return;
  }

  async validatePayment(cart: CartModel, optionalData: { details?: unknown, transactionId?: string }) {
    return await this.api.putPromisedJSON(
      `${PayjunctionService.userCartUrl}/${cart.storeId}/V2/validateOrder`, {
        ...cart,
        payjunctionTransaction: optionalData?.transactionId
      });
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  set _dispatch(_dispatch: AppDispatch) {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  set _storeId(_storeId: string) {}
}
